import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Alert, Button, Dropdown, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import generateExcel from "zipcelx";
import { processData02 } from "./EventHistory02.js";
import { buildRankingExportConfig, RankingParticipantsList } from "./EventHistorySections.js";
import useReportListScroll from "../hooks/useReportListScroll.js";

export default function EventParticipantRankingSection({ dataTable, canEdit, refreshTrigger, onLoadingChange }) {
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [reload, setReload] = useState(0);
  const containerRef = useRef(null);
  const listRef = useRef(null);
  const maxHeight = useReportListScroll(containerRef, listRef, participants);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError("");
    onLoadingChange?.("ranking", true);
    axios.get(`/api/event/participants/${dataTable.evento_id}?platform=${dataTable.platform}`, { signal: controller.signal })
      .then((response) => {
        if (controller.signal.aborted) return;
        const unbounded = { dateRange: { startDate: null, endDate: null } };
        setParticipants(processData02(dataTable, response.data, unbounded, unbounded).rankingParticipants);
      })
      .catch(() => {
        if (!controller.signal.aborted) setError("Não foi possível carregar o ranking de participantes.");
      })
      .finally(() => {
        if (controller.signal.aborted) return;
        setLoading(false);
        onLoadingChange?.("ranking", false);
      });
    return () => controller.abort();
  }, [dataTable, onLoadingChange, refreshTrigger, reload]);

  return <section className="mb-4" aria-label="Ranking de participantes">
    <div className="textHeaderAplicativo d-flex justify-content-between align-items-center gap-2 flex-wrap">
      <h5 className="card-title mb-0">Ranking de participantes ({loading ? "…" : participants.length})</h5>
      <Dropdown>
        <Dropdown.Toggle className="btn-outline-primary" aria-label="Opções do ranking"><FontAwesomeIcon icon={faCog} /></Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item disabled={loading || Boolean(error) || !participants.length} onClick={() => generateExcel(buildRankingExportConfig(participants, dataTable))}>Exportar</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
    <h6 className="text-muted mt-3 mx-2">Resultado final da soma de pontuação e conquistas desbloqueadas pelos Top 50 participantes</h6>
    <div ref={containerRef} className="border rounded p-3 mb-3 event-report-list-scroll" style={{ maxHeight }}
      role="region" aria-label="Participantes no ranking" tabIndex={participants.length > 10 ? 0 : undefined}>
    {loading && <div className="py-4" role="status"><Spinner animation="border" size="sm" className="me-2" />Carregando ranking…</div>}
    {error && <Alert variant="warning" className="d-flex justify-content-between align-items-center gap-2 flex-wrap"><span>{error}</span><Button size="sm" variant="outline-secondary" onClick={() => setReload((value) => value + 1)}>Tentar novamente</Button></Alert>}
    <div hidden={Boolean(error) || (loading && !participants.length)} aria-busy={loading}>
      <RankingParticipantsList listRef={listRef} participants={participants} dataTable={dataTable} canEdit={canEdit} onScoreHistoryChange={() => setReload((value) => value + 1)} />
    </div>
    </div>
  </section>;
}
